
import { EventInput } from "Models";
import { defineComponent, PropType } from "vue";
export default defineComponent({
  emits: ["dateChanged", "update:modelValue"],
  props: {
    modelValue: {},
    modelModifiers: {
      default: () => ({}),
    },
    borderClass: Object,
    placeholder: {
      type: String,
      default: "dd/mm/yyyy",
    },
    inputClass: Object,
    startDate: {
      type: String as PropType<string>,
      default: null,
    },
    endDate: {
      type: String as PropType<string>,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    updateInput($event: EventInput) {
      this.valueChange($event.target.value);
    },
    valueChange(val: string) {
      this.$emit("update:modelValue", val);
    },
    onDateChange(val: Date) {
      this.$emit("dateChanged", val);
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler(val) {
        if (!!val) {
          $(this.$refs.dt).datepicker("setStartDate", val);
        }
      },
    },
    endDate: {
      immediate: true,
      handler(val) {
        if (!!val) {
          $(this.$refs.dt).datepicker("setEndDate", val);
        }
      },
    },
  },
  mounted() {
    const vm = this;
    $(vm.$refs.dt)
      .datepicker({
        format: "dd/mm/yyyy",
        language: "vi",
        autoclose: true
      })
      .on('hide', function (e) {
        e.stopPropagation();
      })
      .on("changeDate", function (ev) {
        vm.valueChange($(vm.$refs.dtInput).val() as string);
        vm.onDateChange(new Date(ev.date.valueOf()));
        $(vm.$refs.dt).datepicker("hide");
      });
  },
});
